import { NavLink, useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getIdTokenFromSession } from "~/lib/utils";

interface ErrorPageProps {
  message: string;
  details: string;
  stack?: string;
}

export default function ErrorPage({ message, details, stack }: ErrorPageProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [idToken, setIdToken] = useState<string | null>(null);

  // Fetch auth session on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const idToken = await getIdTokenFromSession();
        setIdToken(idToken);
      } catch (error) {
        console.error("Error fetching auth session:", error);
        setIdToken(null);
      }
    };

    fetchData();
  }, []);

  // Handle navigation when conditions are met
  useEffect(() => {
    const goOnLoginPage = message === "404" && !idToken;
    if (goOnLoginPage) {
      navigate(import.meta.env.VITE_SITE_ROOT + "signin");
    }
  }, [message, idToken]);

  return (
    <main id="error-page">
      <h1>{message}</h1>
      <p>{details}</p>
      {stack && (
        <pre>
          <code>{stack}</code>
        </pre>
      )}
      {!idToken && (
        <NavLink to={import.meta.env.VITE_SITE_ROOT + "signin"}>
          {t("go_to_login_page")}
        </NavLink>
      )}
    </main>
  );
}
